import Cookies from "js-cookie";
import { useAxios } from "./useAxios";
import { Organization } from "@/interfaces/organizations/Organization";
import { computed } from "vue";
import { setAuthCookie } from "./useAuth";

export const betaTesterOrganizationIds = [767, 77, 322, 922, 802, 529, 393, 398] 

export function useOrganization() {
  const axios = useAxios(process.env.VUE_APP_API_REST_BASE_URL)

  const organization = Cookies.get("organization") ? JSON.parse(Cookies.get("organization") ?? "null") : { id: process.env.VUE_APP_ORGANIZATION_ID };

  const getAll = async () => {
    const response = await axios.get('/organizations')

    return response.data
  }

  /**
   * Choose an organization to use in the dashboard
   * @param organization The organization to choose
   */
  const chooseOrganization = (organization: Organization) => {
    setAuthCookie('organization', JSON.stringify(organization))
  }

  const isBetaTester = computed(() => {
    return betaTesterOrganizationIds.includes(organization?.id)
  })

  return {
    organization,
    getAll,
    chooseOrganization,
    isBetaTester
  }
}